import * as Yup from 'yup'
import { TableHeaderConfig } from '../_EOS/Table'

export const validationSchema = Yup.object().shape({
  asnNumber: Yup.string().trim().required('Número de ASN'),
  asnStateId: Yup.number().required('Required'),
  warehouseId: Yup.number()
    .min(1, 'Debe seleccionar un almacén')
    .required('Required'),
  supplierId: Yup.number()
    .min(1, 'Debe seleccionar un proveedor')
    .required('Required'),
  supplierOriginId: Yup.number()
    .min(1, 'Debe seleccionar un origen')
    .required('Required'),
  typeAsnIncomeId: Yup.number()
    .min(1, 'Debe seleccionar un tipo de ingreso')
    .required('Required'),
  estimatedDate: Yup.date().required()
})

export const headersConfig: TableHeaderConfig[] = [
  { field: 'warehouseName', title: 'Almacén' },
  { field: 'origin', title: 'Origen' },
  { field: 'dispatchedDate', title: 'Fecha Despacho' },
  { field: 'workOrderId', title: 'Orden de Trabajo' },
  { field: 'externalOrderId', title: 'Número de Referencia' },
  { field: 'skuQuantity', title: 'Cantidad de SKU' },
  { field: 'totalUnits', title: 'Cantidad de Unidades' }
]

export const searchFieldOptions: { name: string; value: string }[] = [
  { name: 'OT de Salida', value: 'workOrderId' },
  { name: 'ID de Pedido', value: 'externalOrderId' }
]

export const searchReturnOptions: { name: string; value: string }[] = [
  { name: 'OT de Salida', value: 'workOrderId' },
  { name: 'Tracking Number', value: 'trackingNumber' },
  { name: 'Courier', value: 'courier' }
]
